import React from 'react'
import { Route } from 'react-router-dom'
import Home from '../page/home/index'
import Details from '../page/home/details'
function RouteMap() {
  return (
    <div>
      <Route exact path="/" component={Home} />
      <Route exact path="/details/:id" component={Details} />
    </div>
  )
}
export default RouteMap